"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _redux = require("redux");
var _reducer = _interopRequireDefault(require("../../address/redux/reducer"));
var _reducer2 = _interopRequireDefault(require("../../Pharmacy/redux/reducer"));
var _reducer3 = _interopRequireDefault(require("../../Product/redux/reducer"));
var _reducer4 = _interopRequireDefault(require("../../DefaultLocation/redux/reducer"));
var _reducer5 = _interopRequireDefault(require("../../Category/redux/reducer"));
var _reducer6 = _interopRequireDefault(require("../../Cart/redux/reducer"));
var _reducer7 = _interopRequireDefault(require("../../Home/redux/reducer"));
var _reducer8 = _interopRequireDefault(require("../../uploadRX/redux/reducer"));
var _reducer9 = _interopRequireDefault(require("../../Checkout/redux/reducer"));
var _reducer10 = _interopRequireDefault(require("../../myorders/redux/reducer"));
var _reducer11 = _interopRequireDefault(require("../../wishlist/redux/reducer"));
var _reducer12 = _interopRequireDefault(require("../../notification/redux/reducer"));
var _reducer13 = _interopRequireDefault(require("../../Referrals/redux/reducer"));
// Redux: Root Reducer
var _default = exports.default = (0, _redux.combineReducers)({
  ..._reducer.default,
  ..._reducer2.default,
  ..._reducer3.default,
  ..._reducer4.default,
  ..._reducer5.default,
  ..._reducer6.default,
  ..._reducer7.default,
  ..._reducer8.default,
  ..._reducer9.default,
  ..._reducer10.default,
  ..._reducer11.default,
  ..._reducer12.default,
  ..._reducer13.default
});